// 全名变量
export default {
  userToken: function userToken(state) {
    return state.userToken;
  },
  accessToken: function accessToken(state) {
    return state.accessToken;
  },
  userData: function userData(state) {
    return state.userData;
  },
  theme: function theme(state) {
    return state.theme;
  },
  chooseDept: function chooseDept(state) {
    return state.chooseDept;
  },
  chooseDataScopeDept: function chooseDataScopeDept(state) {
    return state.chooseDataScopeDept;
  },
  status: function status(state) {
    return state.status;
  },
  newUserMenus: function newUserMenus(state) {
    return state.newUserMenus;
  },
  defaultCheckedArray: function defaultCheckedArray(state) {
    return state.defaultCheckedArray;
  },
  studentChooseTree: function studentChooseTree(state) {
    return state.studentChooseTree;
  },
  personChargeData: function personChargeData(state) {
    return state.personChargeData;
  },
  hierarchyTree: function hierarchyTree(state) {
    return state.hierarchyTree;
  },
  dialogVisible: function dialogVisible(state) {
    return state.dialogVisible;
  },
  dialogTitle: function dialogTitle(state) {
    return state.dialogTitle;
  },
  formData: function formData(state) {
    return state.formData;
  },
  labelWidth: function labelWidth(state) {
    return state.labelWidth;
  },
  radioArray: function radioArray(state) {
    return state.radioArray;
  },
  lableArray: function lableArray(state) {
    return state.lableArray;
  },
  access_token: function access_token(state) {
    return state.access_token;
  },
  userMenus: function userMenus(state) {
    return state.userMenus;
  },
  roleTypeData: function roleTypeData(state) {
    return state.roleTypeData;
  },
  userPermissionTypeDialog: function userPermissionTypeDialog(state) {
    return state.userPermissionTypeDialog;
  },
  roleFormData: function roleFormData(state) {
    return state.roleFormData;
  },
  roleFormDialog: function roleFormDialog(state) {
    return state.roleFormDialog;
  },
  defaultPageDialog: function defaultPageDialog(state) {
    return state.defaultPageDialog;
  },
  permissionDialog: function permissionDialog(state) {
    return state.permissionDialog;
  },
  checkedArray: function checkedArray(state) {
    return state.checkedArray;
  },
  userTypes: function userTypes(state) {
    return state.userTypes;
  },
  checkedItemArray: function checkedItemArray(state) {
    return state.checkedItemArray;
  },
  permissions: function permissions(state) {
    return state.permissions;
  },
  previewFileData: function previewFileData(state) {
    return state.previewFileData;
  },
  moduleList: function moduleList(state) {
    return state.moduleList;
  },
  unReadMsgCount: function unReadMsgCount(state) {
    return state.unReadMsgCount;
  }
};